export default __webpack_public_path__ + "images/7de034b9a0a389a8d7bcb038b2cf5ae4-heritage_small.webp";